/**
 *created By Nalinda - Home page hero banners
 */


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.discoutnbook = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1900,
        heroHeight: 930,
        maxWidth: 1500,
        sliderInterval: 'int',
        sliderCurrent: 0,
        sliderLength: 0
    },
    init: function () {
        var _this = this;



        var totalprice = 0;
        var totaldiscountprice = 0;
        var othercartitems = [];
        var getscrolpos = 0;


        var prdocuts = $('[data-ids]');
        var itembox = $('.se-popup.cart .cart-items');

        var selectedbookid;


        $('body').on('click', '.freebookcart', function (e) {
            e.preventDefault();
            selectedbookid = $(this).attr('data-ids');
            if($('.se-pop-gift').length)
            {
                $('body').addClass('allpop-bn gw-first');
            }
            else
            {
                updatecheckout(selectedbookid);
            }

        });

        $('body').on('click', '.stock-wrap .al-product-counts span', function (e) {
            setTimeout(function(){
                var count = 0;
                $('.stock-wrap .al-product-counts input').each(function(){
                    count += parseInt($(this).val());
                });

                var itemp = count>1?" BOOKS":" BOOK";
                if(count == 0)
                {
                    $('.addtocart .items-details').html('0 BOOK - ($0.00)<div>USE THE CODE '+offerdiscountcode+'</div>');
                    $('.pl-groups').removeClass('offeron');
                }
                else
                {
                    var dtxt = "<div>Add 1 more book to get free shipping</div>";
                    if(count > 1) dtxt = "<div>Free shipping has been applied</div>";
                    dtxt = "<div>USE THE CODE  "+offerdiscountcode+"</div>";
                    var scou = Math.ceil(count*19.95*.7*100);
                    $('.addtocart .items-details').html(count + itemp +" ($"+((scou/100).toFixed(2))+")"+dtxt);
                    $('.pl-groups').addClass('offeron');
                }
            },100);

        });

        $('body').on('click', '.offeron .checkoutbtn', function (e) {

            var ids = "";
            var offerin = false;
            $('.stock-wrap .al-product-counts input').each(function(){
                var val = parseInt($(this).val());
                var tid = $(this).attr('data-ids');
                if(val > 0)
                {
                    ids += "updates[" + tid + "]="+val+"&";

                }
            });





            var endurl = '/discount/'+offerdiscountcode+'?redirect=%2Fcheckout';

            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });


        });



        $('body').on('click', '.update.chekout-wrap', function (e) {

            e.preventDefault();
            updatecheckoutwithwrap(selectedbookid);
        });

        $('body').on('click', '.close-btn.popgal', function (e) {

            e.preventDefault();
            $('.se-popup.imagegal').removeClass('show');
            $('body').removeClass('allpop-bn');
        });

        $('body').on('click', '.update.gotogift', function (e) {

            e.preventDefault();
            $('body').addClass('gw-sec');
        });

        $('body').on('click', '.cancel-wrap', function (e) {

            e.preventDefault();
            $('body').removeClass('gw-sec');
        });

        $('body').on('click', '.close-btn-fix.fgfirst,.close-btn-fix.fgsec', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn gw-first gw-sec');
            $(window).scrollTop(getscrolpos);
            $('.se-popup.imagegal').removeClass('show');
        });

        $('body').on('click', '.gotocheckout', function (e) {
            e.preventDefault();
            updatecheckout(selectedbookid);
        });

        $('#gift-note').on('keyup', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $('.left-text').text((max - count) + " Characters Remaining");

            var str = $('textarea#gift-note').val();
            str = str.replace(/[^a-zA-Z 0-9 .,\/#@!$%\^&\*;:{}=\-_`~()]+/g, '');
            $('textarea#gift-note').val(str);

        });
        $('#gift-note').trigger('keyup');

        jQuery.post('/cart/clear.js');

        function updatecheckout(bid) {

            var ids = "";
            if(bid == offerbook)
            {
                ids += "updates[" + bid + "]=2";
            }
            else
            {
                ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
            }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }

            var codel = "aa";

            //var endurl = '/discount/' + offerdiscountcode + '?redirect=%2Fcheckout';
            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }

        function updatecheckoutwithwrap(bid) {

            var ids = "";
            if(bid == offerbook)
            {
                ids += "updates[" + bid + "]=2";
            }
            else
            {
                ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
            }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }


            ids += "&updates["+$('[data-wrap-id]').attr('data-wrap-id')+"]=1"+ "&attributes[gift-wrapping]=true&attributes[gift-note]=" + encodeURIComponent($('#gift-note').val());

            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }


        //image popup

        var ccitem;


        $('.gal-box .main-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.thumbs'
        });
        $('.gal-box .thumbs').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.main-image',
            dots: true,
            focusOnSelect: true
        });



        $('.product .main').click(function (e) {

            getscrolpos =  $(window).scrollTop();

            e.preventDefault();
            var thi = $(this);

            var img0 = thi.attr('data-im0');
            var img1 = thi.attr('data-im1');
            var img2 = thi.attr('data-im2');
            var img3 = thi.attr('data-im3');
            var hh = thi.attr('data-name');
            var pp = thi.attr('data-des');

            ccitem = thi.parents('.product').find('input');
            var icount = ccitem.val();


            $('.gal-box .galehead h2').html(hh);
            $('.gal-box .galehead p').html(pp);
            $('.gal-box  .img0').attr('src', img0);
            $('.gal-box .img1').attr('src', img1);
            $('.gal-box  .img2').attr('src', img2);
            $('.gal-box  .img3').attr('src', img3);

            $('.gal-bot .freebookcart').attr('data-ids', $(this).parent().find('.freebookcart').attr('data-ids'));



            setTimeout(function(){
                $('.se-popup.imagegal').addClass('show');
                $('body').addClass('allpop-bn');
            },200);

        });

        // $('.gal-box').on('click', '.thumbs img', function (e) {
        //     e.preventDefault();
        //     $('.gal-box .main-image img').attr('src', $(this).attr('src'));
        //
        // });

        $('.gal-bot').on('click', '.add', function (e) {
            e.preventDefault();
            ccitem.val($('.gal-bot input').val());
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');
            $(window).scrollTop(getscrolpos);
            updateOffer();
        });

        $('body').on('click', '.pl-groups:not(.offeron) .checkout-btn', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');

        });


    }


};


